import { UserTaskEntryObject } from '@libs/types/src/services/object-type/user/user-task-entry.object';

export interface UserTaskEntryExtendedObject extends UserTaskEntryObject {
    children?: UserTaskEntryObject[];
    isNew?: boolean;
    isEdit?: boolean;
}

export enum UserTaskAppointmentStatus {
    INTIME = 'intime',
    LATE = 'late'
}
